import React from "react";
import {
  withStyles,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
} from "@material-ui/core";
import styles from "./dialogStyles";

const DialogBox = ({ classes, children, handleClose, stopDetails, theme }) => {
  return (
    <Dialog
      aria-labelledby="proNotes"
      open={true}
      classes={{ paper: classes.dialog }}
      className={`${classes.dialogWrapper} ${theme}`}
    >
      <DialogTitle
        disableTypography
        handleClose={handleClose}
        id="proNotes-title"
        classes={{ root: classes.dialogTitle }}
      >
        <Grid container xs={12} className={classes.headerContainer}>
          <Grid xs={12} className={classes.stopStatusContainer}>
            <Grid xs={9} className={classes.statusPadding}>
              <span className={classes.stopStatusLabel}>Stop Status:</span>
              <span className={classes.stopStatusValue}>
                {stopDetails.stopStatus}
              </span>
            </Grid>
            <Grid xs={3} className={classes.stopTime}>
              {stopDetails.stopTime}
            </Grid>
          </Grid>
          <Grid className={classes.addressPadding}>
            <span className={classes.dialogTitleText}>
              {stopDetails.stopName}
            </span>
            <span className={classes.dialogSubTitleText}>
              {stopDetails.stopAddress}
            </span>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default withStyles(styles)(DialogBox, { withTheme: true });
